export enum SidebarItemType {
    Content,
    Index,
    Bookmarks,
    Search
}


// WEBPACK FOOTER //
// ./ClientApp/services/state/sidebarItemType.ts